var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-image-container"},[_c('el-dialog',{attrs:{"visible":_vm.visible,"width":_vm.dialogWidth,"show-close":true,"custom-class":"image-viewer-dialog","center":""},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.close}},[_c('div',{staticClass:"image-wrapper"},[_c('img',{style:({
          maxWidth: '100%',
          maxHeight: _vm.imageInfo.maxHeight + 'px'
        }),attrs:{"src":_vm.imageInfo.url},on:{"error":_vm.handleImageError}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }